import { Injectable } from '@angular/core';

export type ThemePreference = 'system' | 'light' | 'dark';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private static readonly storageKey = 'aegis-theme-preference';
  private readonly darkClass = 'ion-palette-dark';
  private preference: ThemePreference = 'system';
  private mediaQuery?: MediaQueryList;
  private readonly onSystemThemeChanged = (): void => {
    if (this.preference === 'system') this.applyPalette();
  };

  initialize(): ThemePreference {
    this.preference = this.readPreference();
    this.mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    this.mediaQuery.addEventListener('change', this.onSystemThemeChanged);
    this.applyPalette();
    return this.preference;
  }

  getPreference(): ThemePreference {
    return this.preference;
  }

  setPreference(preference: ThemePreference): void {
    this.preference = preference;
    try {
      localStorage.setItem(ThemeService.storageKey, preference);
    } catch {
      // Safari private browsing等で保存領域が使えない場合も、その場の表示は切り替える。
    }
    this.applyPalette();
  }

  private readPreference(): ThemePreference {
    try {
      const saved = localStorage.getItem(ThemeService.storageKey);
      if (saved === 'system' || saved === 'light' || saved === 'dark') return saved;
    } catch {
      // 保存できない環境では端末設定に従う。
    }
    return 'system';
  }

  private applyPalette(): void {
    const useDarkPalette = this.preference === 'dark'
      || (this.preference === 'system' && this.mediaQuery?.matches === true);
    document.documentElement.classList.toggle(this.darkClass, useDarkPalette);
  }
}
